export const getEnableClose = (): boolean => {
  if (sessionStorage.getItem("enableClose")) {
    return sessionStorage.getItem("enableClose") === "true"
  }

  return false
}

export const setEnableClose = (enableClose: "true" | "false"): void => {
  sessionStorage.setItem("enableClose", enableClose)
}
